// INCLUDES
import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";

// Vue-Headful to allow modifying of the Title
/*import vueHeadful from 'vue-headful';
app.component('vue-headful', vueHeadful);*/


// FONT AWESOME - used for icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas);

// FLOATING VUE - used for tooltips (replacement for v-tooltip)
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

// MOMENT.JS - for date handling
import moment from 'moment';

// LOCALIZATION
import messages from "@/language";
import { createI18n } from "vue-i18n";
import getLocale from "@/utils/getLocale";

// DATE PICKER - ensure safe defaults for optional props
import VueDatePicker from '@vuepic/vue-datepicker';

// Guard against upstream bug: default dayClass should be a function
const DatePickerComponent = VueDatePicker as unknown as { props?: Record<string, any> };
if (DatePickerComponent?.props?.dayClass) {
  DatePickerComponent.props.dayClass.default = () => '';
}

const locale = getLocale();
const i18n = createI18n({
  locale, // set locale
  legacy: false, // Use composition API mode
  messages // set locale messages
});

// digitalData
import { initDigitalData } from "@/plugins/digitalData";
initDigitalData(router, store);

// Initialize components
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import StepHeader from "./components/StepHeader.vue";
import BottomNav from "./components/BottomNav.vue";
import StepWrapper from "./components/StepWrapper.vue";
import { Carousel, Slide } from "vue3-carousel";

// Create the main Vue app
const app = createApp(App);

// Use plugins
app.use(i18n);
app.use(router);
app.use(store);
app.use(FloatingVue);

// Add global properties for Vue 3
app.config.globalProperties.$moment = moment;

// Register global components
app.component("header-view", Header);
app.component("footer-view", Footer);
app.component("stepheader-view", StepHeader);
app.component("bottomnav-view", BottomNav);
app.component("stepwrapper-view", StepWrapper);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("Icon", FontAwesomeIcon); // Alias for backward compatibility
app.component("carousel", Carousel);
app.component("slide", Slide);

// Mount the app
app.mount("#app");
